import "@/sentry";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const sentryHandler = Sentry.reactErrorHandler();
// Sentry swallows the console line — in dev a crash otherwise leaves a blank page with no trace.
const reportAndLog = (error, info) => {
  if (process.env.NODE_ENV !== "production") console.error("[react] uncaught render error:", error, info?.componentStack);
  return sentryHandler(error, info);
};
const root = ReactDOM.createRoot(document.getElementById("root"), {
  // React 19 root hooks — the only way to see errors a boundary already handled.
  onUncaughtError: reportAndLog,
  onCaughtError: reportAndLog,
  onRecoverableError: Sentry.reactErrorHandler(),
});
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
